import React, { useRef } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import OurSafeCustomer from "../our-safe-customer";
import CovidLandingHeader from "../covid-landing-header";
import Button from "../../shared/button";
import AlertCard from "../../shared/alert-card/component";
import SellCarSafely from "../sell-car-safely";
import ContainerSticky from "../../shared/container-sticky";
import { LOCAL_STORAGE_KEYS } from "../../../constants/app-constants";
import getNumberWithOffset from "../../../utils/helpers/get-number-with-offset";
import { getParticularDay } from "../../../utils/helpers/get-day-from-date";

const CovidProtection = ({
    history,
    updateLeadSourceConnect
}) => {
    const topContainerRef = useRef();
    const bottomContainerRef = useRef();

    const onClickBookAppointment = () => {
        updateLeadSourceConnect(LOCAL_STORAGE_KEYS.AB_COVID);
        history.push("/car-evaluation");
    };

    const getInspectedCarNumber = () => {
        return getNumberWithOffset({ offset: getParticularDay(new Date()) });
    };

    return (
        <React.Fragment>
            <div ref={topContainerRef} />
            <CovidLandingHeader/>
            <SellCarSafely />
            <OurSafeCustomer/>
            <div ref={bottomContainerRef} />
            <ContainerSticky
                offset={130}
                bottomOffset={0}
                thresholdRef={bottomContainerRef}
                elementRef={topContainerRef}
                isInitiallyMounted={true}
            >
                <div styleName={"styles.footerBox styles.fixedFooter"}>
                    <div className="container d-flex">
                        <h3>
                        Book appointment for FREE car inspection<br/>
                        at your home or nearest Cars24 branch
                        </h3>
                        <div styleName={"styles.alertBox"}>
                            <AlertCard variant={"green"}>
                                {getInspectedCarNumber()}
                                &nbsp;customers got their car inspected yesterday!
                            </AlertCard>
                        </div>
                        <div>
                            <Button
                                text="BOOK APPOINTMENT NOW"
                                onClick={onClickBookAppointment}
                            />
                        </div>
                    </div>
                </div>
            </ContainerSticky>
        </React.Fragment>
    );
};

CovidProtection.propTypes = {
    history: PropTypes.object,
    updateLeadSourceConnect: PropTypes.func
};

export default CovidProtection;
